import { useState } from 'react';
import { Download, Upload } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { hasRole } from '@conversia/shared-types';
import * as conversationsApi from '@/api/conversations.api';
import { useAuthStore } from '@/store/auth.store';
import { useMenu } from '@/hooks/useMenu';
import { useToast } from '@/hooks/useToast';

/**
 * «DESCARGAR EXCEL» EN CHATS (tanda 3, F20). El botón vivía solo en /crm, que no
 * está en el menú del dueño. Es la misma descarga (ADMIN, tope de 50.000 filas)
 * con las columnas de su ficha.
 *
 * Tanda 5: en la reunión del 5-oct el dueño tocó «Excel» creyendo que ahí se SUBÍA su
 * lista de clientes («¿A dónde yo me voy aquí para cargar mi Excel?»). Ahora son dos
 * botones con su verbo: «Bajar» y «Subir Excel» (que lleva al importador).
 */
const BOTON =
  'flex h-9 shrink-0 items-center gap-1.5 rounded-md border border-surface-border px-2.5 text-sm text-slate-600 hover:bg-slate-100 disabled:opacity-50 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800';

export function DescargarExcelView({ cargando, onClick }: { cargando: boolean; onClick: () => void }) {
  return (
    <button type="button" onClick={onClick} disabled={cargando} aria-label="Descargar Excel" title="Bajar un Excel con todos tus leads" className={BOTON}>
      <Download className="h-4 w-4" />
      <span className="hidden lg:inline">Bajar</span>
    </button>
  );
}

export function SubirExcelView({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" onClick={onClick} aria-label="Subir Excel" title="Subir tu Excel de clientes al sistema" className={BOTON}>
      <Upload className="h-4 w-4" />
      <span className="hidden lg:inline">Subir Excel</span>
    </button>
  );
}

export function DescargarExcel() {
  const role = useAuthStore((s) => s.user?.role);
  const toast = useToast();
  const navigate = useNavigate();
  const { datos: menu } = useMenu();
  const [cargando, setCargando] = useState(false);
  if (!role || !hasRole(role, 'ADMIN')) return null;
  // «Subir» solo si el negocio tiene el importador: el servidor dice qué rutas existen.
  const puedeSubir = menu?.rutas.some((r) => r.ruta === '/contacts/importar') ?? false;
  return (
    <>
      {puedeSubir && <SubirExcelView onClick={() => navigate('/contacts/importar')} />}
      <DescargarExcelView
        cargando={cargando}
        onClick={() => {
          setCargando(true);
          void conversationsApi
            .downloadCrmExport()
            .then(() => toast.success('Excel descargado'))
            .catch(() => toast.error('No se pudo generar el Excel'))
            .finally(() => setCargando(false));
        }}
      />
    </>
  );
}
